'use client'

import { usePathname } from 'next/navigation'

import { splitLocalePrefix } from '@/lib/i18n/config'

/**
 * `usePathname()` without the locale segment: `/de/explore` reads as
 * `/explore`, so a component that compares the path with a route works in
 * every language.
 */
export function useUnlocalizedPathname(): string | null {
  const pathname = usePathname()
  return pathname === null ? null : splitLocalePrefix(pathname).path
}
